import { session } from 'utils/storage';

const DISMISSED_ORDER_SESSION_STORAGE_KEY = 'dismissedAmendTooltipOrderId';

export const isAmendOrderAlertTooltipOpen = (
  currentCustomerOrderId: string | undefined,
  dismissedAmendTooltipOrderId: string | undefined,
): boolean => currentCustomerOrderId !== dismissedAmendTooltipOrderId;

export const getDismissedAmendTooltipOrderId = (): string | undefined =>
  session.get(DISMISSED_ORDER_SESSION_STORAGE_KEY) || undefined;

export const setDismissedAmendTooltipOrderId = (customerOrderId: string): void => {
  session.set(DISMISSED_ORDER_SESSION_STORAGE_KEY, customerOrderId);
};
